import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import UnrealClassViewer from './UnrealClassView';

const SDKView = () => {
    const location = useLocation();
    const { jsonfiles, gamename } = location.state || {};
    const [classes, setClasses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClass, setSelectedClass] = useState(null);
    const classListRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (jsonfiles) {
            try {
                const files = JSON.parse(jsonfiles);
                setClasses(files.map(fileUrl => ({
                    name: fileUrl.split('/').pop().replace('.json', ''),
                    url: fileUrl
                })));
            } catch (error) {
                console.error('Error parsing JSON files:', error);
            }
        }
    }, [jsonfiles]);

    const loadClassDetailView = (fileUrl) => {
        setSelectedClass(fileUrl);
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const debounce = (fn, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn(...args), delay);
        };
    };

    const debouncedSearch = debounce(handleSearch, 150);

    const filteredClasses = classes.filter(classItem => 
        classItem.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (selectedClass) {
        return (
            <UnrealClassViewer 
                dataUrl={selectedClass}
                previousView={gamename}
                onReturn={() => setSelectedClass(null)}
            />
        );
    }

    return (
        <div ref={containerRef} className="min-h-screen text-white font-sans">
            <div className="container mx-auto p-4 sm:p-6 md:p-8">
                <h1 className="text-3xl sm:text-4xl font-bold text-center mb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-red-600 to-red-700 animate-headerGlow">
                    Class List For: {gamename || 'Game Name'}
                </h1>
                <input 
                    type="text" 
                    className="w-full p-2 text-base sm:text-lg rounded border border-gray-700 bg-gray-800 text-white outline-none mb-4 transition-all duration-200 shadow-sm focus:border-gray-600 focus:shadow-lg transform focus:-translate-y-0.5 placeholder-gray-500"
                    placeholder="Search classes..." 
                    aria-label="Search classes" 
                    onChange={debouncedSearch}
                />
                <div ref={classListRef} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
                    {filteredClasses.map((classItem, index) => (
                        <div 
                            key={index} 
                            className="p-2 sm:p-3 bg-gray-800 border border-gray-700 rounded cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-600 hover:shadow-md focus:outline-none focus:border-gray-500"
                            onClick={() => loadClassDetailView(classItem.url)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    loadClassDetailView(classItem.url);
                                }
                            }}
                            tabIndex="0"
                            role="listitem"
                        >
                            <p className="text-sm sm:text-base">{classItem.name}</p>
                        </div>
                    ))}
                </div>
                <Link 
                    to="/unreal-db" 
                    className="fixed bottom-4 sm:bottom-8 left-4 sm:left-8 text-gray-400 text-xs sm:text-sm hover:text-white transition-colors"
                >
                    Back to Unreal DB?
                </Link>
            </div>
        </div>
    );
};

export default SDKView;